export default __webpack_public_path__ + "static/treeData-14068be62de10d9c334d0f6633c7b6c4.gif";